import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import React from "react";

import { XBRimg, XbrWhite } from "../../../assets/index.js";

const LiquiditySelect = ({
  dropDownRef,
  setIsOpen,
  isOpen,
  tokens,
  selectedToken,
  tokenValue,
  changeTokenValue,
  handleTokenChange,
  setNewMax,
  cardName,
  paletteMode,
}) => {
  return (
    <div>
      <form className="w-full relative">
        <label className="sr-only" htmlFor="token-input">
          Enter your number
        </label>
        <input
          autoComplete="off"
          id="token-input"
          className="w-full h-[46px] pl-4 md:h-16 md:pl-6 
          bg-lightBlue text-[14px] dark:bg-darkButBg sm:text-sm md:leading-6 
          md:text-base uppercase text-black dark:text-white 
          rounded-lg placeholder:text-lightBlack !font-light 
          dark:placeholder:text-lightWhite focus:outline-none"
          type="text"
          placeholder={`00.00 ${selectedToken.name}`}
          onWheel={(e) => e.preventDefault()}
          onChange={changeTokenValue}
          value={tokenValue}
        />
        <div className="flex gap-1 md:gap-2 absolute top-0 right-2 h-full items-center">
          {cardName === "Token 1" && (
            <button
              type="button"
              className="h-[30px] md:h-10 px-4 text-xs text-black md:text-sm font-medium leading-[18px] md:leading-[21px] uppercase flex items-center justify-center border border-deepBlue rounded-lg bg-white shadow-maxButtonShadow dark:bg-darkCardBg dark:text-white"
              onClick={setNewMax}
            >
              Max
            </button>
          )}
          <div className="relative" ref={dropDownRef}>
            <button
              type={"button"}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
              className={
                "h-[30px] md:h-10 flex items-center justify-between px-2 md:px-4 py-3 bg-white dark:bg-darkCardBg dark:text-white rounded-lg shadow-selectionShadow gap-2"
              }
            >
              <div className="flex items-center justify-center md:gap-2">
                <img
                  src={
                    selectedToken.name === "XBR"
                      ? paletteMode === "light"
                        ? XbrWhite
                        : XBRimg
                      : selectedToken.image
                  }
                  alt={selectedToken.name}
                  className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                />
                <span className="hidden  text-black dark:text-white md:block text-sm font-medium leading-[21px]">
                  {selectedToken.name}
                </span>
              </div>
              {isOpen ? (
                <ChevronUpIcon className="w-[14px] h-[14px] md:w-5 md:h-5 fill-black dark:fill-white" />
              ) : (
                <ChevronDownIcon className="w-[14px] h-[14px] md:w-5 md:h-5 fill-black dark:fill-white" />
              )}
            </button>
            {isOpen && (
              <div
                className={
                  "absolute w-full mt-1 shadow-selectionShadow bg-white border border-gray-300 dark:bg-darkCardBg rounded-xl z-50"
                }
              >
                {tokens.map((token) => (
                  <div
                    key={token.id}
                    className={
                      "px-1 md:px-4 rounded-xl py-2  flex items-center gap-1 md:gap-2 cursor-pointer hover:bg-lightgray-200 dark:hover:bg-darkButBg"
                    }
                    onClick={() => {
                      handleTokenChange(token);
                    }}
                  >
                    <img
                      src={token.image}
                      alt={token.name}
                      className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                    />
                    <span className="text-[10px] md:text-sm text-black dark:text-white font-medium leading-[21px]">
                      {token.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default LiquiditySelect;
